export default [
  {
    path: '/players',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'PlayerList',
        component: () => import('./containers/PlayerListContainer'),
      },
    ],
  },
]
